<template>
  <div class="succes">
    <h1>MERCI !</h1>

    <img id="image_succes" src="../assets/check.png" alt="succes" />

    <p id="texte_succes">
      La demande d'inscription de votre enfant a bien été prise en compte, elle va désormais être traitée dans
      les plus brefs délais.<br /><br />
      Pour toute question :
      <a class="lien_succes" href="tel:0372330320">03 72 33 03 20</a>
      ou sur
      <a class="lien_succes" href="mailto:bonjour@reseau-colibri.fr">bonjour@reseau-colibri.fr</a>
    </p>
  </div>
</template>

<script setup></script>

<style lang="scss">
@import '../sass/app';

.succes {
  color: $thirdcolor;
  text-align: center;
  @include media-breakpoint-up(lg) {
    padding: 0 20rem 0 20rem;
  }

  #image_succes {
    width: 20%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    @include media-breakpoint-down(xs) {
      width: 50%;
    }
  }

  #texte_succes {
    margin-top: 1rem;

    .lien_succes {
      color: $thirdcolor;
      font-weight: 900;
      font-size: 20px !important;
    }
    .lien_succes:hover {
      color: $secondcolor;
      text-decoration: none;
    }
  }
}
</style>